module.exports = __webpack_public_path__ + "./images/07764ca81de86caee8ac27a8bbab8e30.webp";